<div class="dialog-container">
    <!-- Dialog Header -->
    <div class="dialog-header mb-4">
        <h4 class="dialog-title mb-0">Start Meeting - {{ meetingTitle }}</h4>
        <button type="button" class="close-btn" (click)="onCancel()" aria-label="Close dialog">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 5L5 15M5 5L15 15" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>

    <!-- Back to agenda list link -->
    <div class="mb-3">
        <a href="#" class="back-link" (click)="goBackToAgendaList(); $event.preventDefault()">
            <i class="fas fa-arrow-left me-2"></i> Back to agenda list
        </a>
    </div>

    <!-- Agenda Items Navigation -->
    <div class="agenda-navigation mb-3" *ngIf="agendaItems.length > 1">
        <div class="agenda-items-list">
            <div 
                *ngFor="let item of agendaItems; let i = index" 
                class="agenda-item-tab"
                [class.active]="i === currentAgendaIndex"
                (click)="selectAgendaItem(i)">
                <span class="agenda-tab-number">{{ i + 1 }}</span>
                <span class="agenda-tab-subject">{{ item.subject }}</span><span class="agenda-stage-pill" [ngClass]="getAgendaStageClass(item.currentStage)" *ngIf="item.currentStage">{{ item.currentStage }}</span>
            </div>
        </div>
    </div>

    <!-- Dialog Content -->
    <form [formGroup]="meetingForm" *ngIf="currentAgendaItem">
        <!-- Agenda Title Section -->
        <div class="form-section">
            <h5 class="section-title fw-bold">Agenda Title</h5>
            <div class="agenda-title-box">
                <div class="agenda-subject fw-bold d-flex align-items-center gap-2 flex-wrap">{{ currentAgendaItem?.subject || 'N/A' }}<span class="agenda-stage-pill" [ngClass]="getAgendaStageClass(currentAgendaItem?.currentStage)" *ngIf="currentAgendaItem?.currentStage">{{ currentAgendaItem?.currentStage }}</span></div>
                <div class="agenda-datetime text-muted mt-2">{{ currentAgendaItem?.dateTime || 'N/A' }}</div>
            </div>
        </div>

        <!-- Agenda Description Section -->
        <div class="form-section">
            <h5 class="section-title fw-bold">Agenda Description</h5>
            <div class="row">
                <div class="col-12 col-md-6 mb-3 mb-md-0">
                    <div class="description-column">
                        <div class="description-label fw-bold mb-2">English</div>
                        <div class="description-content p-3">
                            {{ currentAgendaItem?.descriptionEnglish || 'No English description available.' }}
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="description-column">
                        <div class="description-label fw-bold mb-2">العربية (Arabic)</div>
                        <div class="description-content p-3">
                            {{ currentAgendaItem?.descriptionArabic || 'لا يوجد وصف بالعربية.' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <!-- Required from tender committee Section -->
        <div class="form-section">
            <h5 class="section-title fw-bold">Required from tender committee</h5>
            <div class="required-from-tc p-3">
                {{ currentAgendaItem?.requiredFromTC || 'N/A' }}
            </div>
        </div>

        <!-- TC Notes -->
        <div class="form-section">
            <h5 class="section-title fw-bold">TC Notes</h5>
            <div class="row">
                <div class="col-12 mb-3 mb-md-0">
                    <div class="description-column">
                        <div class="description-label fw-bold mb-2">Notes</div>
                        <div class="description-content p-3">
                            {{ currentAgendaItem?.tcNotes || 'No TC Notes available.' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- TC Decision EN Section -->
        <div class="form-section">
            <h5 class="section-title fw-bold">TC Decision EN</h5>
            <textarea 
                class="form-control" 
                rows="4"
                formControlName="tcDecisionEN"
                placeholder="Enter Tender Committee decision in English...">
            </textarea>
        </div>

        <!-- Dialog Footer -->
        <div class="dialog-footer d-flex justify-content-between align-items-center">
            <button type="button" class="btn end-meeting-btn" (click)="onEndMeeting()">
                End Meeting
            </button>
            <div class="d-flex gap-2">
                <button 
                    type="button" 
                    class="btn back-btn" 
                    (click)="onBack()"
                    [disabled]="!hasPrevious">
                    Back
                </button>
                <button 
                    type="button" 
                    class="btn next-btn" 
                    (click)="onNext()"
                    [disabled]="!hasNext">
                    Next
                </button>
            </div>
        </div>
    </form>
</div>
